export var MOMRegion;
(function (MOMRegion) {
    MOMRegion["CN"] = "cn";
    MOMRegion["EU"] = "eu";
    MOMRegion["US"] = "us";
    MOMRegion["LOCAL"] = "local";
})(MOMRegion || (MOMRegion = {}));
export var EnvironmentCluster;
(function (EnvironmentCluster) {
    EnvironmentCluster["CN_ALI_PLATFORM"] = "ali-platform";
    EnvironmentCluster["CN_DEV"] = "cn1-dev";
    EnvironmentCluster["CN_PROD"] = "cn1";
    EnvironmentCluster["DEMO"] = "demo";
    EnvironmentCluster["DEV"] = "dev";
    EnvironmentCluster["EDGE"] = "edge";
    EnvironmentCluster["EPHEMERAL"] = "ephemeral";
    EnvironmentCluster["EU"] = "eu1";
    EnvironmentCluster["EU_DEV"] = "eu1-dev";
    EnvironmentCluster["INT_DEV"] = "int-dev";
    EnvironmentCluster["LOCAL"] = "local";
    EnvironmentCluster["PLATFORM"] = "platform";
    EnvironmentCluster["PROD"] = "prod";
    EnvironmentCluster["QA"] = "qa";
    EnvironmentCluster["TEST"] = "test";
})(EnvironmentCluster || (EnvironmentCluster = {}));
export var MOMClusterType;
(function (MOMClusterType) {
    MOMClusterType["DEV"] = "dev";
    MOMClusterType["EPHEMERAL"] = "ephemeral";
    MOMClusterType["INTERNAL"] = "internal";
    MOMClusterType["PROD"] = "prod";
})(MOMClusterType || (MOMClusterType = {}));
